import Formulario from "./formulario";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  setDadosAction,
  setRespostaAction,
  getDadosFormularioAction,
  setDadosFormularioAction,
} from "../../../store/kyc/actions";

const getRespostaEscolhida = (pergunta) => pergunta && pergunta.RespostaEscolhida.IdRespostaFormulario;

const mapStateToProps = (state, nextState) => ({
  formulario: state.formularioReducer,
  IdRespostaOutros:
    getRespostaEscolhida(state
      .formularioReducer
      .dados
      .Assuntos
      .find((a) => a.IdAssuntoFormulario === 'e22dda4d-3f11-4d4e-b368-c795cc45aad2')
      .Perguntas
      .find((p) => p.IdPerguntaFormulario === '87d95cbb-a6ff-44d4-b3e8-8c56d64af757'))
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setDadosAction,
      setRespostaAction,
      getDadosFormularioAction,
      setDadosFormularioAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Formulario);
